// noinspection JSUnresolvedReference

(function(app) {
    let colorMap = {};
    const elements = {};

    app.LayerColorSelection = {
        init() {
            colorMap = app.Store.getState('colorMap');

            elements.layerDisplayEls = document.querySelectorAll(`.wdpp-display--layer-color`);
            elements.layerLabelEls = document.querySelectorAll(`.wdpp-label-color.wdpp-layers`);
            elements.layerLabelPriceEls = document.querySelectorAll(`.wdpp-label-color-price.wdpp-layers`);
            
            // Add base color display elements
            elements.baseDisplayEl = document.querySelector(`.wdpp-display--text-color`);
            elements.baseLabelEl = document.querySelector(`.wdpp-label-color.wdpp-line`);
            elements.baseLabelPriceEl = document.querySelector(`.wdpp-label-color-price.wdpp-line`);

            // app.Store.subscribe('textColor', (color) => this.updateColorDisplay(color));
            app.Store.subscribe('layerColors', (colors) => this.updateLayerColorsDisplay(colors));

            const colorGrids = document.querySelectorAll('.wdpp-color-grid.wdpp-layers, .wdpp-color-grid.wdpp-line[data-is-for-text="false"]');
            
            // Validate required elements
            if (!app.Utils.validateElements('color inputs for layers', {
                'color grids': colorGrids
            })) {
                return;
            }

            if (!app.Store.getState('layerColors')) {
                app.Store.setState('layerColors', []);
            }

            // Keep track of all color selections to apply
            const pendingColorSelections = [];

            colorGrids.forEach(colorGrid => {
                const isBaseLayer = colorGrid.classList.contains('wdpp-line');
                const colorElements = colorGrid.querySelectorAll(isBaseLayer ? '.wdpp-color-box.wdpp-line' : '.wdpp-color-box.wdpp-layers');
                
                colorElements.forEach(colorElement => {
                    const layerId = isBaseLayer ? 'base' : colorElement.getAttribute('data-layer-id');
                    const colorName = colorElement.getAttribute('data-color');
                    colorElement.style.backgroundColor = colorMap[colorName].hex;

                    colorElement.addEventListener('click', () => {
                        colorElements.forEach(el => el.classList.remove('selected'));
                        colorElement.classList.add('selected');

                        const currentColors = [...(app.Store.getState('layerColors') || [])].filter(color => color.id !== layerId);
                        currentColors.push({
                            id: layerId,
                            name: colorName
                        });
                        app.Store.setState('layerColors', currentColors);
                    });
                });

                // Set default color and add to pending selections
                const defaultColor = colorGrid.getAttribute('data-default-color');
                let defaultColorElement;
                
                if (defaultColor) {
                    defaultColorElement = Array.from(colorElements).find(el =>
                        el.getAttribute('data-color') === defaultColor
                    );
                } else if (colorElements.length > 0) {
                    defaultColorElement = colorElements[0];
                }
                
                if (defaultColorElement) {
                    pendingColorSelections.push(defaultColorElement);
                    
                    // Also set the selected class
                    colorElements.forEach(el => el.classList.remove('selected'));
                    defaultColorElement.classList.add('selected');
                }

                // Still keep the canvas ready listener for safety
                app.Store.subscribe('canvasReady', () => {
                    if (defaultColorElement) {
                        defaultColorElement.click();
                    }
                });
            });

            // Now immediately apply all default colors
            if (pendingColorSelections.length > 0) {
                // Apply all pending color selections
                pendingColorSelections.forEach(element => {
                    const layerId = element.closest('.wdpp-color-grid').classList.contains('wdpp-line') ? 
                        'base' : element.getAttribute('data-layer-id');
                    const colorName = element.getAttribute('data-color');
                    
                    const currentColors = [...(app.Store.getState('layerColors') || [])].filter(color => color.id !== layerId);
                    currentColors.push({
                        id: layerId,
                        name: colorName
                    });
                    app.Store.setState('layerColors', currentColors);
                });
            }
        },

        // updateColorDisplay(colorName) {
        //     if (elements.textDisplayEl) {
        //         elements.textDisplayEl.textContent = colorName;
        //         elements.textDisplayEl.style.setProperty('--display-color', colorMap[colorName].hex);
        //     }
        //
        //     if (elements.textLabelEl) {
        //         elements.textLabelEl.textContent = colorMap[colorName].friendlyName;
        //     }
        //
        //     if (elements.textLabelPriceEl) {
        //         elements.textLabelPriceEl.textContent = colorMap[colorName].priceMultiplier;
        //     }
        // },

        updateLayerColorsDisplay(colors) {
            colors.forEach((color) => {
                const { id, name } = color;
                
                // Handle base layer separately
                if (id === 'base') {
                    if (elements.baseDisplayEl) {
                        elements.baseDisplayEl.textContent = name;
                        elements.baseDisplayEl.style.setProperty('--display-color', colorMap[name].hex);
                    }

                    if (elements.baseLabelEl) {
                        elements.baseLabelEl.textContent = colorMap[name].friendlyName;
                    }

                    if (elements.baseLabelPriceEl) {
                        const priceMultiplier = colorMap[name].priceMultiplier;
                        elements.baseLabelPriceEl.textContent = priceMultiplier > 0 ? `(pris +${priceMultiplier * 100}%)` : '';
                    }
                    return;
                }
                
                // Handle other layers
                elements.layerDisplayEls.forEach(el => {
                    if (el.getAttribute('data-layer-id') === id) {
                        el.textContent = name;
                        el.style.setProperty('--display-color', colorMap[name].hex);
                    }
                });

                elements.layerLabelEls.forEach(el => {
                    if (el.getAttribute('data-layer-id') === id) {
                        el.textContent = colorMap[name].friendlyName;
                    }
                });

                elements.layerLabelPriceEls.forEach(el => {
                    if (el.getAttribute('data-layer-id') === id) {
                        const priceMultiplier = colorMap[name].priceMultiplier;
                        el.textContent = priceMultiplier > 0 ? `(pris +${priceMultiplier * 100}%)` : '';
                    }
                });
            });
        },

        /**
         * Get the color data for cart export
         * @returns {object} The color data for the cart
         */
        getCartData() {
            return {
                layerColors: app.Store.getState('layerColors') || []
            };
        },

        /**
         * Get the color data for price calculation
         * @returns {object} The color data for the price
         */
        getPriceData() {
            return {
                layerColors: app.Store.getState('layerColors') || []
            };
        }
    };
})(window.app = window.app || {});